/**
 * Indica se o defensor pode abrir o relatório no editor (não somente leitura).
 * Alinhado à lista de relatórios: só rascunho e reprovado exibem ação de editar.
 */
export function defensorPodeAbrirEditorDoRelatorioAtividade(status: unknown): boolean {
  const s = String(status ?? '').toLowerCase();
  return s === 'rascunho' || s === 'reprovado';
}
